/**
 * @generated SignedSource<<a18b9f50f7adcc83b63b1b411dd45634>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreviousBookingsStepClientProfile$data = {
  readonly member: {
    readonly " $fragmentSpreads": FragmentRefs<"PreviousBookingsListClient">;
  } | null | undefined;
  readonly " $fragmentType": "PreviousBookingsStepClientProfile";
};
export type PreviousBookingsStepClientProfile$key = {
  readonly " $data"?: PreviousBookingsStepClientProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreviousBookingsStepClientProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forSlotId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreviousBookingsStepClientProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "forSlotId",
              "variableName": "forSlotId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PreviousBookingsListClient"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientProfile",
  "abstractKey": "__isClientProfile"
};

(node as any).hash = "71309b590adfb353bb15b57e94a7ea9e";

export default node;
